import React from 'react';
import { ArrowUpDown } from 'lucide-react';
import { Button } from './ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const IstatMobileSort = ({ column, ascending, onColumn, onDirection }) => (
  <div className="flex items-center gap-2 p-3 sm:hidden" data-testid="istat-mobile-sort">
    <Select value={column} onValueChange={onColumn}>
      <SelectTrigger className="min-w-0 flex-1" aria-label="Ordina immobili per" data-testid="istat-mobile-sort-field"><SelectValue /></SelectTrigger>
      <SelectContent data-testid="istat-mobile-sort-options">
        {[
          ['property_name', 'Immobile'], ['region', 'Regione'], ['total_days', 'Giorni totali'],
          ['sent_days', 'Inviati'], ['pending_days', 'Da inviare'], ['status', 'Stato'],
        ].map(([value, label]) => <SelectItem key={value} value={value} data-testid={`istat-mobile-sort-${value.replaceAll('_', '-')}`}>{label}</SelectItem>)}
      </SelectContent>
    </Select>
    <Button size="sm" variant="outline" onClick={onDirection} data-testid="istat-mobile-sort-direction" aria-label="Inverti ordinamento">
      <ArrowUpDown className="h-4 w-4 mr-1" />{ascending ? 'Crescente' : 'Decrescente'}
    </Button>
  </div>
);